import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

type CalendarSearchHighlightContextType = {
  searchTerm: string
  setSearchTerm: (term: string) => void
}

const CalendarSearchHighlightContext = createContext<CalendarSearchHighlightContextType>({
  searchTerm: '',
  setSearchTerm: () => { /* no provider means no dimming */ }
})

type Props = {
  children: ReactNode
}

export const CalendarSearchHighlightProvider = ({ children }: Props) => {
  const [searchTerm, setSearchTerm] = useState('')
  const value = useMemo(() => ({ searchTerm, setSearchTerm }), [searchTerm])

  return (
    <CalendarSearchHighlightContext.Provider value={value}>
      {children}
    </CalendarSearchHighlightContext.Provider>
  )
}

export const useCalendarSearchHighlight = () => useContext(CalendarSearchHighlightContext)
